import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FormData, FormErrors, OrderType } from '../../hooks/useCheckoutForm';
import { PickupForm } from './PickupForm';
import { DeliveryForm } from './DeliveryForm';
import { OrderTypeTabs } from './OrderTypeTabs';

interface CheckoutFormProps {
  formData: FormData;
  errors: FormErrors;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onTakeoutOrder: () => void;
  onContinue: () => void;
  orderLoading: boolean;
  paymentMode: 'pay_now' | 'pay_later';
  quoteLoading: boolean;
  cartItemsCount: number;
  showPayNow?: boolean;
  showPayLater?: boolean;
  showDelivery?: boolean;
  activeTab: OrderType;
  setActiveTab: (tab: OrderType) => void;
}

export const CheckoutForm: React.FC<CheckoutFormProps> = ({
  formData,
  errors,
  handleChange,
  onSubmit,
  onTakeoutOrder,
  onContinue,
  orderLoading,
  paymentMode,
  quoteLoading,
  cartItemsCount,
  showPayNow = true,
  showPayLater = true,
  showDelivery = false,
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      {/* Animated Tab Switcher */}
      <OrderTypeTabs
        activeTab={activeTab}
        onTabChange={setActiveTab}
        showDelivery={showDelivery}
      />

      {/* Animated Form Content */}
      <AnimatePresence mode="wait">
        {(!showDelivery || activeTab === 'pickup') ? (
          <motion.div
            key="pickup"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <PickupForm
              formData={formData}
              errors={errors}
              handleChange={handleChange}
              onSubmit={onSubmit}
              onTakeoutOrder={onTakeoutOrder}
              orderLoading={orderLoading}
              paymentMode={paymentMode}
              cartItemsCount={cartItemsCount}
              showPayNow={showPayNow}
              showPayLater={showPayLater}
            />
          </motion.div>
        ) : (
          <motion.div
            key="delivery"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <DeliveryForm
              formData={formData}
              errors={errors}
              handleChange={handleChange}
              onContinue={onContinue}
              quoteLoading={quoteLoading}
              cartItemsCount={cartItemsCount}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
